<li [class.active]="isActive" [class.desktop]="onlyDesktop" class="nav-item">
  <ng-container *ngIf="iconType === 'iconly' else bsIcon">
    <i  class="{{ icon }}"></i>
  </ng-container>
  <ng-template #bsIcon>
    <i-bs [name]="iconBs" width="14" height="14"></i-bs>
  </ng-template>
  <h6>{{ name }}</h6>
  <div class="warning" *ngIf="warningMessage" [tooltip]="warningMessage">
    <i-bs name="exclamation-diamond-fill"></i-bs>
  </div>
</li>
